import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Workspace from "./pages/Workspace";
import SharePage from "./pages/SharePage";
import RealtorDashboard from "./pages/RealtorDashboard";
import ListingDetails from "./pages/ListingDetails";
import SellerPortal from "./pages/SellerPortal";
import DeployBanner from "./components/DeployBanner";
import { isAuthed } from "./lib/auth";

function Protected({ children }) {
  return isAuthed() ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <DeployBanner />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/share/:token" element={<SharePage />} />
        <Route path="/seller/:token" element={<SellerPortal />} />
        <Route path="/r/:token" element={<RealtorDashboard />} />
        <Route
          path="/listings/:id"
          element={
            <Protected>
              <ListingDetails />
            </Protected>
          }
        />
        <Route
          path="/app"
          element={
            <Protected>
              <Workspace />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
